import React, { useEffect, useRef } from "react"
import { faSort, faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useSortBy, useTable } from "react-table";

const CustomTable = ({ data, columnData, showFilters = true, manualSort = false, onSortChange, sortState }) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        state: { sortBy },
        setSortBy,
    } = useTable(
        {
            columns: columnData,
            data,
            manualSortBy: manualSort,
            autoResetSortBy: !manualSort,
            initialState: sortState ? { sortBy: [sortState] } : {},
        },
        useSortBy
    );

    useEffect(() => {
        if (!manualSort) return;
        const target = sortState ? [sortState] : [];
        const current = sortBy ?? [];
        const stringify = (value) => JSON.stringify(value ?? []);
        if (stringify(current) !== stringify(target)) {
            setSortBy(target);
        }
    }, [manualSort, sortState, setSortBy]);

    const previousSortRef = useRef();

    useEffect(() => {
        if (!manualSort || !onSortChange) return;
        const current = sortBy?.[0]
            ? { id: sortBy[0].id, desc: !!sortBy[0].desc }
            : null;
        const previous = previousSortRef.current;
        if (
            (current && previous && current.id === previous.id && current.desc === previous.desc) ||
            (!current && !previous)
        ) {
            return;
        }
        previousSortRef.current = current;
        onSortChange(current);
    }, [manualSort, onSortChange, sortBy]);

    return (
        <table className="table-main mb-2 striped" {...getTableProps()}>
            <thead>
                {
                    headerGroups?.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup?.headers?.map((column) => (
                                <th
                                    {...column?.getHeaderProps(column.getSortByToggleProps())}
                                    style={{
                                        cursor: 'pointer',
                                        padding: '10px',
                                    }}
                                >
                                    {column?.render('Header')}
                                    {
                                        column.canSort && (
                                            <span style={{ marginLeft: '10px' }}>
                                                {column?.isSorted ? (
                                                    column?.isSortedDesc ? (
                                                        <FontAwesomeIcon icon={faSortDown} /> // Icon for descending sort
                                                    ) : (
                                                        <FontAwesomeIcon icon={faSortUp} /> // Icon for ascending sort
                                                    )
                                                ) : (
                                                    <FontAwesomeIcon icon={faSort} /> // Default icon (unsorted state)
                                                )}
                                            </span>)
                                    }
                                </th>
                            ))}
                        </tr>
                    ))
                }
            </thead>
            <tbody {...getTableBodyProps()}>
                {data?.length === 0 ? (
                    <tr>
                        <td colSpan={columnData?.length} style={{ textAlign: 'center', padding: '10px' }}>
                            No data available in table
                        </td>
                    </tr>
                ) : rows?.map((row) => {
                    prepareRow(row);
                    return (
                        // style={{ backgroundColor: 'lightblue' }}
                        <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => (
                                <td
                                    {...cell.getCellProps()}
                                    style={{
                                        padding: '10px',
                                    }}
                                >
                                    {cell.render('Cell')}
                                </td>
                            ))}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    )
}
export default CustomTable
